import { axiosInstance } from '.'
import { LIST_OPPORTUNITY_NEWS, OPPORTUNITY_NEWS_BY_ID } from './endpoints'

export type OpportunityNewsItem = {
  id: number
  externalId: string
  opportunityDomain: string
  opportunityTitle: string | null
  releaseDate: string
  headline: string
  description: string | null
  link: string | null
  thumbnailUrl: string | null
  spotlight: boolean
  articles: unknown[]
  fetchedAt: string
}

export type OpportunityNewsPagination = {
  total: number
  limit: number
  offset: number
  count: number
}

export type OpportunityNewsDraft = {
  headline: string
  description: string
  link: string
  thumbnailUrl: string
  spotlight: boolean
}

export type OpportunityNewsUpdateData = {
  headline: string
  description: string | null
  link: string | null
  thumbnailUrl: string | null
  spotlight: boolean
}

export const opportunityNewsServices = {
  list: async (params: { limit: number; offset: number }) => {
    try {
      const response = await axiosInstance.get(LIST_OPPORTUNITY_NEWS, { params })
      return response
    } catch (error: any) {
      return error.response
    }
  },

  update: async (id: number, data: OpportunityNewsUpdateData) => {
    try {
      const response = await axiosInstance.put(OPPORTUNITY_NEWS_BY_ID(id), data)
      return response
    } catch (error: any) {
      return error.response
    }
  },

  remove: async (id: number) => {
    try {
      const response = await axiosInstance.delete(OPPORTUNITY_NEWS_BY_ID(id))
      return response
    } catch (error: any) {
      return error.response
    }
  },
}
